module.exports = __webpack_public_path__ + "static/media/Dhairya_Patel.41ddb949.jpeg";